<div class="p-3">
    <h5 class="text-center mt-3">{{title}}</h5>
    <p class="text-center mt-3">{{message}}</p>
    <div class="d-flex justify-content-center mt-4">
        <button class="btn light-blue-button  mx-2" (click)="Confirm()">Confirm</button>
        <button class="btn transparent-button mx-2" (click)="Cancel()">Cancel</button>
    </div>
</div>